import { render, staticRenderFns } from "./BranchMenu.vue?vue&type=template&id=923e489e&scoped=true&"
import script from "./BranchMenu.vue?vue&type=script&lang=js&"
export * from "./BranchMenu.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./BranchMenu.vue?vue&type=style&index=1&id=923e489e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923e489e",
  null
  
)

export default component.exports